const ENVIRONMENT_IDS = [
  "gov-nonprod",
  "gov-prod",
  "commercial-prod",
];

const all = {
  "gov-nonprod": true,
  "gov-prod": true,
  "commercial-prod": true,
};

const govOnly = {
  "gov-nonprod": true,
  "gov-prod": true,
  "commercial-prod": false,
};

const commercialOnly = {
  "gov-nonprod": false,
  "gov-prod": false,
  "commercial-prod": true,
};

const govProdOnly = {
  "gov-nonprod": false,
  "gov-prod": true,
  "commercial-prod": false,
};

const govNonprodOnly = {
  "gov-nonprod": true,
  "gov-prod": false,
  "commercial-prod": false,
};

const capabilityMatrix = {
  home: all,
  oncall: all,
  addTestPatient: commercialOnly,
  customerSupport: all,
  sentryActivity: all,
  uploadTo4d: commercialOnly,
  templates: all,
  workflows: all,
  customDictionary: all,
  reviewNote: all,
  reviewTranscript: all,
  allJobs: all,
  coding: all,
  mlWorkflows: all,
  datasets: all,
  trace: all,
  argus: all,
  externalView: all,
  registerDoctors: all,
  updateDoctors: all,
  transcriptionRules: all,
  userFeedback: all,
  modelEval: all,
  externalUsage: all,
  csTools: all,
  clickupEscalation: all,
  testNote: all,
  escalationCallbacks: commercialOnly,
  smartChart: govOnly,
  vaDeactivateUsers: govOnly,
  qaEval: govOnly,
  vaEval: govOnly,
  vaRegister: govOnly,
  karoline: govOnly,
  foiaTracking: govOnly,
  financialReview: govOnly,
  commercialFinancialReview: commercialOnly,
  notifications: all,
  outreach: govOnly,
  outreachSlack: govProdOnly,
  moveTranscript: all,
  commercialDashboardMetrics: all,
  evaluation: commercialOnly,
  patientManagement: commercialOnly,
  hallucination: commercialOnly,
  paymentReconcile: commercialOnly,
  revops: commercialOnly,
  integrations: commercialOnly,
  oncoemr: commercialOnly,
  boomerang: commercialOnly,
  workflowsVisualization: commercialOnly,
  mc: govNonprodOnly,
  restrictedPatientWindow: govOnly,
  hideDeletedPatients: commercialOnly,
};

const ENVIRONMENT_ALIASES = {
  "gov-nonprod": "gov-nonprod",
  gov_nonprod: "gov-nonprod",
  va_non_prod: "gov-nonprod",
  "va-non-prod": "gov-nonprod",
  govdev: "gov-nonprod",
  "gov-dev": "gov-nonprod",
  nonprod: "gov-nonprod",
  development: "gov-nonprod",
  dev: "gov-nonprod",
  "gov-sandbox": "gov-nonprod",
  gov_sandbox: "gov-nonprod",
  "gov-prod": "gov-prod",
  gov_prod: "gov-prod",
  va_prod: "gov-prod",
  "va-prod": "gov-prod",
  govprd: "gov-prod",
  gov: "gov-prod",
  "commercial-prod": "commercial-prod",
  commercial_prod: "commercial-prod",
  commercial: "commercial-prod",
  prod: "commercial-prod",
  production: "commercial-prod",
};

function normalizeEnvironmentId(value) {
  const normalized = String(value || "commercial-prod").trim().toLowerCase();
  const environmentId = ENVIRONMENT_ALIASES[normalized];
  if (!environmentId) {
    throw new Error(
      `Unknown capability environment "${value}". Expected one of: ${ENVIRONMENT_IDS.join(", ")}`
    );
  }
  return environmentId;
}

function getClientEnvironmentId() {
  return normalizeEnvironmentId(
    process.env.REACT_APP_ENVIRONMENT_ID ||
      process.env.REACT_APP_ONCALL_ENV ||
      process.env.REACT_APP_ENV ||
      "commercial-prod"
  );
}

function isCapabilityEnabled(capabilityKey, environmentId = getClientEnvironmentId()) {
  const capability = capabilityMatrix[capabilityKey];
  if (!capability) {
    throw new Error(`Unknown capability "${capabilityKey}"`);
  }
  return capability[normalizeEnvironmentId(environmentId)] === true;
}

function isAnyCapabilityEnabled(capabilityKeys, environmentId = getClientEnvironmentId()) {
  return (Array.isArray(capabilityKeys) ? capabilityKeys : [capabilityKeys]).some((key) =>
    isCapabilityEnabled(key, environmentId)
  );
}

module.exports = {
  ENVIRONMENT_IDS,
  capabilityMatrix,
  normalizeEnvironmentId,
  getClientEnvironmentId,
  isCapabilityEnabled,
  isAnyCapabilityEnabled,
};
